import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Prompt } from 'react-router-dom';
import cuid from 'cuid';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@ccm-office/ccm-ui';
import { INavigationCallback, INavigationPromptProps } from './types';
import useStyles from './style';

// @TODO improve this (avoid the usage of window and transitionCallbackRef)
function NavigationPrompt({ message, title, when }: INavigationPromptProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const transitionIdRef = useRef(`transition_${cuid()}`);
  const transitionCallbackRef = useRef<INavigationCallback>();

  const handleOpen = useCallback(
    (transitionCallback) => {
      setOpen(true);
      transitionCallbackRef.current = transitionCallback;
    },
    [setOpen]
  );
  const handleClose = useCallback(() => {
    setOpen(false);
    transitionCallbackRef.current && transitionCallbackRef.current(false);
  }, [setOpen]);
  const handleConfirmation = useCallback(() => {
    setOpen(false);
    transitionCallbackRef.current && transitionCallbackRef.current(true);
  }, [setOpen]);

  useEffect(() => {
    const transitionId = transitionIdRef.current;
    // @TODO find proper typing for window[attr]
    // @ts-ignore
    window[transitionId] = handleOpen;
    // @ts-ignore
    return () => {
      // @ts-ignore
      delete window[transitionId];
    };
  }, [handleOpen]);

  return (
    <React.Fragment>
      <Prompt when={when} message={transitionIdRef.current} />
      <Dialog data-testid="unsaved-dialog" open={open} onClose={handleClose}>
        <DialogTitle className={classes.title} data-testid="dialog-header" disableTypography={true}>
          <InfoOutlined className={classes.icon} />
          <Typography className={classes.titleText} data-testid="dialog-title" variant="h4">
            {title || t('title.unsavedData')}
          </Typography>
        </DialogTitle>
        <DialogContent data-testid="dialog-content" className={classes.content}>
          <DialogContentText data-testid="dialog-message">
            {message || t('message.withoutSaving')}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actions} data-testid="dialog-actions">
          <Button variant="text" data-testid="close-button" onClick={handleClose}>
            {t('button.no')}
          </Button>
          <Button variant="text" autoFocus data-testid="action-button" onClick={handleConfirmation}>
            {t('button.yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default NavigationPrompt;
